<sc-flex [fitHeight]="true" [vertical]="true" [stretchContent]="true">
  <sc-flex-fitting-content [vertical]="true">
      <app-transport-list [componentIdentifier]="widgetIdentifier+'-transport-table'" [transports]="data"
        [columnsToDisplay]="columnsToDisplay" [selectedTransportId]="selectedTransportId"
        [sortDefinition]="currentFilterSortDefinition"
        (transportSelected)="onTransportSelected($event)"></app-transport-list>
  </sc-flex-fitting-content>
  <sc-content-spacer [vertical]="true"></sc-content-spacer>
  <app-transport-counts
    [counts]="transportCounts"></app-transport-counts>
</sc-flex>